import React from 'react'
import './Footer.css'

function Footer () {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Aquí puedes agregar el contenido del footer */}
        <span>© {new Date().getFullYear()} METAL MECANICA MACON. Todos los derechos reservados.</span>
      </div>
      <div>
        <a href="/aviso-de-privacidad" className="footer-privacy-link">Aviso de privacidad</a>
      </div>
    </footer>
  )
}

export default Footer
